var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Help__Wrapper"},[_c('div',{staticClass:"Interface__Help",on:{"click":function($event){return _vm.getFile()}}},[_c('div',{staticClass:"Interface__HelpIcon"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }